/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How the client authenticates at the issuer's token endpoint. Omit to default to client_secret_basic.
 */
export const TokenEndpointAuthMethod = {
  ClientSecretBasic: "client_secret_basic",
  ClientSecretPost: "client_secret_post",
  None: "none",
} as const;
/**
 * How the client authenticates at the issuer's token endpoint. Omit to default to client_secret_basic.
 */
export type TokenEndpointAuthMethod = ClosedEnum<
  typeof TokenEndpointAuthMethod
>;

/**
 * Form for creating a global remote_session_client. Caller supplies client_id (and optional client_secret) obtained out-of-band from the upstream issuer.
 */
export type CreateGlobalRemoteSessionClientForm = {
  /**
   * Optional upstream OAuth audience to send on the authorize redirect and token exchange.
   */
  audience?: string | undefined;
  /**
   * client_id supplied by the caller.
   */
  clientId: string;
  /**
   * client_secret supplied by the caller. Speakeasy encrypts before persisting.
   */
  clientSecret?: string | undefined;
  /**
   * The owning global remote_session_issuer id.
   */
  remoteSessionIssuerId: string;
  /**
   * Explicit upstream OAuth scopes the dance should request for this client. Omit to fall back to the issuer's scopes_supported.
   */
  scope?: Array<string> | undefined;
  /**
   * How the client authenticates at the issuer's token endpoint. Omit to default to client_secret_basic.
   */
  tokenEndpointAuthMethod?: TokenEndpointAuthMethod | undefined;
};

/** @internal */
export const TokenEndpointAuthMethod$outboundSchema: z.ZodMiniEnum<
  typeof TokenEndpointAuthMethod
> = z.enum(TokenEndpointAuthMethod);

/** @internal */
export type CreateGlobalRemoteSessionClientForm$Outbound = {
  audience?: string | undefined;
  client_id: string;
  client_secret?: string | undefined;
  remote_session_issuer_id: string;
  scope?: Array<string> | undefined;
  token_endpoint_auth_method?: string | undefined;
};

/** @internal */
export const CreateGlobalRemoteSessionClientForm$outboundSchema: z.ZodMiniType<
  CreateGlobalRemoteSessionClientForm$Outbound,
  CreateGlobalRemoteSessionClientForm
> = z.pipe(
  z.object({
    audience: z.optional(z.string()),
    clientId: z.string(),
    clientSecret: z.optional(z.string()),
    remoteSessionIssuerId: z.string(),
    scope: z.optional(z.array(z.string())),
    tokenEndpointAuthMethod: z.optional(TokenEndpointAuthMethod$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      clientId: "client_id",
      clientSecret: "client_secret",
      remoteSessionIssuerId: "remote_session_issuer_id",
      tokenEndpointAuthMethod: "token_endpoint_auth_method",
    });
  }),
);

export function createGlobalRemoteSessionClientFormToJSON(
  createGlobalRemoteSessionClientForm: CreateGlobalRemoteSessionClientForm,
): string {
  return JSON.stringify(
    CreateGlobalRemoteSessionClientForm$outboundSchema.parse(
      createGlobalRemoteSessionClientForm,
    ),
  );
}
